export function target(v: any[]|undefined, p: {[key: string]: any}, k: string) {
    p[k] = v; // @todo convert to target model
}